const PropTypes = require('prop-types');
const React = require('react');
const Tooltip = require('components/tooltip');

class MediaMailInput extends React.Component {
  checkedValue() {
    return this.props.mediaMailQualified ? 'checked' : '';
  }

  hiddenFieldValue() {
    return this.props.mediaMailQualified ? '1' : '0';
  }

  render() {
    if (!this.props.eligibleForMediaMail) return null;

    return (
      <div>
        <div className="label-with-checkbox">
          <input
            name="shipping_label_form[media_mail_qualified]"
            type="hidden"
            value={this.hiddenFieldValue()}
          />
          <input
            type="checkbox"
            value="1"
            checked={this.checkedValue()}
            name="shipping_label_form[media_mail_qualified]"
            id="shipping_label_form[media_mail_qualified]"
            onChange={this.props.toggleMediaMailQualified}
          />
          <label htmlFor="shipping_label_form[media_mail_qualified]" className="normal">
            <span className="mr-half">
              {I18n.t('js.dashboard.selling.shippingLabels.mediaMail.title')}
            </span>
            <Tooltip
              title={I18n.t('js.dashboard.selling.shippingLabels.mediaMail.tooltipHtml', { lineBreak: '<br>', linkOpen: '<a class="color-white underlined" target="_blank" href="https://about.usps.com/notices/not121/not121_tech.htm">', linkClose: '</a>' })}
            />
          </label>
        </div>
      </div>
    );
  }
}

MediaMailInput.propTypes = {
  eligibleForMediaMail: PropTypes.bool.isRequired,
  mediaMailQualified: PropTypes.bool.isRequired,
  toggleMediaMailQualified: PropTypes.func.isRequired,
};

module.exports = MediaMailInput;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/media_mail_input.jsx